import axios, { AxiosInstance } from 'axios';
import Interceptor from './interceptor';
import { token } from 'services/LocalStorage/localStorage';

let axiosInstance: AxiosInstance | null = null;
const apiVersion = 'v1.0';

const getAxiosInstance = () => {
    const userToken = token.get();
    if (!axiosInstance) {
        const url = new URL(document.URL);
        let baseURL: string | undefined = '';
        try {
            baseURL =
                process.env.NODE_ENV === 'development'
                    ? `${process.env.REACT_APP_BASE_URL}/${apiVersion}/`
                    : `${url.origin}/${apiVersion}/`;
        } catch (e) {
            console.log(`please check env.js exists and is not broken.  ${e}`);
        }

        axiosInstance = axios.create({
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            baseURL,
        });

        Interceptor.interceptor(axiosInstance);
    }

    if (userToken) {
        axiosInstance.defaults.headers.common.Authorization = `Bearer ${userToken}`;
        axiosInstance.defaults.headers.common.withCredentials = false;
    }
    return axiosInstance;
};

export const network = getAxiosInstance();
